webpackJsonp([9],{

/***/ 294:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(26)(
  /* script */
  __webpack_require__(686),
  /* template */
  __webpack_require__(772),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 582:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(41);

var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();

/***/ }),

/***/ 610:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 686:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_graphql__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_event_bus_js__ = __webpack_require__(582);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      User: {
        Organization: {
          User: [],
          Admin: [],
          Device: []
        }
      },
      organizationCode: '',
      organizationName: '',
      createOrg: false,
      snackbar: false,
      snackBarText: '',
      snackbarColor: '',
      timeOut: 5000
    };
  },

  apollo: {
    User: {
      query: __WEBPACK_IMPORTED_MODULE_0__constants_graphql__["e" /* USER_QUERY */],
      variables: function variables() {
        return {
          id: this.$store.getters.user.id
        };
      }
    }
  },
  created: function created() {
    var _this = this;

    this.$store.commit('setShowStepOrganization', false);
    __WEBPACK_IMPORTED_MODULE_1__lib_event_bus_js__["a" /* EventBus */].$on('go-back', function () {
      _this.$store.commit('setShowStepOrganization', false);
    });
  },

  methods: {
    newOrganizationButton: function newOrganizationButton() {
      this.$store.commit('setShowStepOrganization', true);
      this.createOrg = true;
    },
    joinOrganization: function joinOrganization() {
      var _this2 = this;

      if (!this.$store.getters.isOnline) {
        this.snackbar = true;
        this.snackBarText = 'Sin conexión! Intenta nuevamente más tarde';
        this.snackbarColor = 'red';
        return;
      }
      if (!this.organizationCode.length) {
        this.snackbar = true;
        this.snackBarText = 'Debe ingresar un código primero';
        this.snackbarColor = 'red';
        return;
      }
      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_0__constants_graphql__["f" /* HASH_ORGANIZATION_QUERY */],
        variables: {
          hash: this.organizationCode.toUpperCase()
        }
      }).then(function (result) {
        if (result.data && result.data.allOrganizations && result.data.allOrganizations[0]) {
          var organizationId = result.data.allOrganizations[0].id;
          _this2.$apollo.mutate({
            mutation: __WEBPACK_IMPORTED_MODULE_0__constants_graphql__["g" /* UPDATE_USER_ORGANIZATION_MUTATION */],
            variables: {
              userId: _this2.$store.getters.user.id,
              orgId: organizationId
            }
          }).then(function (result) {
            _this2.$apollo.queries.User.refresh();
            _this2.$router.push({ name: 'UserInfo' });
          });
        } else {
          _this2.snackbar = true;
          _this2.snackBarText = 'El código no corresponde a ninguna organización';
          _this2.snackbarColor = 'red';
        }
      }).catch(function () {});
    },
    createOrganizationButton: function createOrganizationButton() {
      var _this3 = this;

      if (!this.$store.getters.isOnline) {
        this.snackbar = true;
        this.snackBarText = 'Sin conexión! Intenta nuevamente más tarde';
        this.snackbarColor = 'red';
      } else {
        if (!this.organizationName.length) {
          this.snackbar = true;
          this.snackBarText = 'Debes definir un nombre primero';
          this.snackbarColor = 'red';
        } else {
          var hash = this.makeHash(4);
          this.$apollo.mutate({
            mutation: __WEBPACK_IMPORTED_MODULE_0__constants_graphql__["h" /* CREATE_ORGANIZATION_MUTATION */],
            variables: {
              name: this.organizationName,
              hash: hash
            }
          }).then(function (result) {
            var organizationId = result.data.createOrganization.id;
            _this3.User.Organization = {
              id: organizationId,
              name: result.data.createOrganization.name
            };
            _this3.$apollo.mutate({
              mutation: __WEBPACK_IMPORTED_MODULE_0__constants_graphql__["g" /* UPDATE_USER_ORGANIZATION_MUTATION */],
              variables: {
                userId: _this3.$store.getters.user.id,
                orgId: organizationId
              }
            }).then(function (result) {
              _this3.User.Organization.User = result.data.updateOrganization.User;
              _this3.$apollo.mutate({
                mutation: __WEBPACK_IMPORTED_MODULE_0__constants_graphql__["i" /* UPDATE_ORGANIZATION__ADMIN_MUTATION */],
                variables: {
                  orgId: organizationId,
                  userId: _this3.$store.getters.user.id
                }
              }).then(function (result) {
                _this3.User.Organization.Admin = result.data.updateOrganization.Admin;
                _this3.$apollo.queries.User.refresh();
                _this3.$router.push({ name: 'UserInfo', params: { organizationCreated: true } });
              }).catch(function () {});
            }).catch(function () {});
          }).catch(function () {});
        }
      }
    },
    makeHash: function makeHash(length) {
      var result = '';
      var characters = 'ABCDEFGJKLMNOPQRSTUVWXYZ0123456789';
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    }
  }
});

/***/ }),

/***/ 772:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.createOrg) ? _c('v-container', {
    staticClass: "organization",
    attrs: {
      "fluid": ""
    }
  }, [_c('app-snackbar', {
    attrs: {
      "text": _vm.snackBarText,
      "show": _vm.snackbar,
      "color": _vm.snackbarColor,
      "timeOut": _vm.timeOut
    },
    on: {
      "update:show": function($event) {
        _vm.snackbar = $event
      }
    }
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "flex",
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('p', {
    staticClass: "font title"
  }, [_vm._v("Introduce el código de la organización")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "font input-text",
    attrs: {
      "prepend-inner-icon": "domain",
      "name": "name",
      "append-outer-icon": "send",
      "label": "Código de la organización",
      "type": "name"
    },
    on: {
      "click:append-outer": _vm.joinOrganization
    },
    model: {
      value: (_vm.organizationCode),
      callback: function($$v) {
        _vm.organizationCode = $$v
      },
      expression: "organizationCode"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "div-create-org"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": __webpack_require__(610)
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "font create-org-button",
    on: {
      "click": _vm.newOrganizationButton
    }
  }, [_vm._v("Crear organización")])])], 1)], 1) : _c('v-container', {
    staticClass: "organization",
    attrs: {
      "fluid": ""
    }
  }, [_c('app-snackbar', {
    attrs: {
      "text": _vm.snackBarText,
      "show": _vm.snackbar,
      "color": _vm.snackbarColor,
      "timeOut": _vm.timeOut
    },
    on: {
      "update:show": function($event) {
        _vm.snackbar = $event
      }
    }
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "flex",
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('p', {
    staticClass: "font title"
  }, [_c('b', [_vm._v("Nombra a la organización")])]), _vm._v(" "), _c('v-text-field', {
    staticClass: "font input-text",
    attrs: {
      "prepend-inner-icon": "domain",
      "name": "name",
      "label": "Nombre de la organización",
      "type": "name"
    },
    model: {
      value: (_vm.organizationName),
      callback: function($$v) {
        _vm.organizationName = $$v
      },
      expression: "organizationName"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "div-continue-btn"
  }, [_c('v-btn', {
    class: this.organizationName.length ? 'continue-btn' : 'continue-btn grey--text',
    attrs: {
      "block": "",
      "color": this.organizationName.length ? 'info' : '#DFDFDF'
    },
    on: {
      "click": _vm.createOrganizationButton
    }
  }, [_vm._v("Crear organización")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/9.1e5f7cb1979b51ffe4e7.js